import { useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

/**
 * Bottom-sheet drawer used by the mobile bottom nav's "More" tab.
 * Lists secondary navigation links for the current role.
 */
export default function MobileMoreSheet({ open, onClose, items }) {
  // Lock body scroll while open.
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;
  return (
    <div className="lg:hidden fixed inset-0 z-50 flex items-end" data-testid="mobile-more-sheet">
      <div
        className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="relative w-full bg-cream-50 rounded-t-3xl border-t border-cream-200 shadow-2xl animate-sheet-up"
        style={{ maxHeight: "85dvh", paddingBottom: "env(safe-area-inset-bottom)" }}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-center justify-between px-5 pt-5 pb-3">
          <h3 className="text-lg font-heading font-black text-slate-900">المزيد من الأقسام</h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center min-h-11 min-w-11 rounded-lg text-slate-500 hover:bg-white/70"
            aria-label="إغلاق"
            data-testid="mobile-more-close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="mx-auto h-1 w-10 rounded-full bg-slate-300 -mt-1 mb-2" aria-hidden="true" />
        <nav className="px-3 pb-4 overflow-y-auto max-h-[70dvh]">
          {items.map((item, idx) => {
            if (item.section) {
              return (
                <div key={`s-${idx}`} className="mt-3 pt-3 border-t border-cream-200 px-2 pb-1 text-[10px] font-black uppercase tracking-widest text-slate-400">
                  {item.section}
                </div>
              );
            }
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                onClick={onClose}
                className="flex items-center gap-3 min-h-12 px-3 py-2 rounded-xl text-sm font-semibold text-slate-800 hover:bg-white/70 active:bg-white transition-colors"
                data-testid={`more-${item.testId || item.to}`}
              >
                <span className="grid h-9 w-9 place-items-center rounded-xl bg-white border border-cream-200 text-teal-700 shrink-0">
                  {Icon ? <Icon className="h-4 w-4" strokeWidth={2} /> : null}
                </span>
                <span className="flex-1 truncate">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
